import { render, staticRenderFns } from "./settings-organization-widget.vue?vue&type=template&id=62ce195f&scoped=true&"
import script from "./settings-organization-widget.vue?vue&type=script&lang=js&"
export * from "./settings-organization-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ce195f",
  null
  
)

export default component.exports